import { call, put, takeLatest } from "redux-saga/effects";
import history from "../routes/history";
import { toast } from "react-toastify";
import Api from "../api";
import queryString from "query-string";
import {
  GET_SITE_DATA,
  getSiteDataRequested,
  getSiteDataSuccess,
  getSiteDataFailure,
  leadDataRequested,
  leadDataFailure,
  LEAD_DATA,
  LEAD_DATA_CALLBACK,
} from "../actions/manage-site-action-type";
import Utils from "../utils";

const {
  httpHelper: { getRequest, postRequest },
} = new Utils().getAll();

const host = Utils.getHost();
export function* getManageSiteData({ payload }) {
  const payloadData = {
    headers: {
      Authorization: "c2xkZ21sa21nbG1s",
    },
    url: `${host.apiUrl}manage-client/list/${payload}/${host.websiteUrl}`,
  };

  yield put(getSiteDataRequested());

  try {
    const { data, error } = yield call(getRequest, payloadData);
    if (data && !error) {
      yield put(getSiteDataSuccess(data.response));

      let queries = queryString.parse(
        history.location.search ? history.location.search.toLowerCase() : ""
      );

      if (
        queries &&
        queries?.transaction_id === "102a0deea395c1b6f188a299a288cc"
      ) {
        yield call(forwardTo, "/page-not-found");
      }
      Api.trackImpression(data.response, queries);
    } else {
      yield put(getSiteDataFailure(error));
      yield call(forwardTo, "/page-not-found10");
    }
  } catch (error) { }
}

export function* postLeadData({ payload }) {
  if (isKnownLeadMatch(payload)) {
    Api.redirectToThankyouPage(payload);
    return;
  }
  const phonecheckdata = {
    url: `${host.apiUrl}duplicatephonecheck/${payload.phone_number}/${payload.site_id}`,
  };
  const { data, error } = yield call(getRequest, phonecheckdata);

  // if (["www.2023.mylifeinsurancecompare.co.nz", "2023.mylifeinsurancecompare.co.nz"].includes(payload.domain)) {
  //   var d = sessionStorage.getItem("domain");
  //   if (d) {
  //     payload = {
  //       ...payload,
  //       domain: d
  //     }
  //   }
  // }


  const payloadData = {
    data: payload,
    url: `${host.apiUrl}add-lead`,
  };
  if (data.DuplicatePhone === false && !error) {
    yield put(leadDataRequested());
    try {
      const { data, error } = yield call(postRequest, payloadData);
      if (data && !error) {
        if(["quickandeasyhearing.com","www.quickandeasyhearing.com","www.au2.quickandeasyhearing.com", "au2.quickandeasyhearing.com","au3.qehearing.com","loan.financesolver.co","carloan.financesolver.co","au-life.financesolver.co","www.au-life.financesolver.co","nz2.quickandeasyhearing.com","www.nz2.quickandeasyhearing.com"].includes(host.websiteUrl)){
          const resp = {
            email: payload.email,
            phone: payload.phone_number,
            first_name: payload.fName || (payload.full_name ? payload.full_name.split(' ')[0] : undefined),
            last_name: payload.lName || (payload.full_name ? payload.full_name.split(' ')[1] : undefined),
            postcode: payload.postcode,
            state: payload.state,
            suburb: payload.suburb || (payload.postcode && payload.postcode.split(', ')[0])
          };

          // Only include fields that are not empty or null
          const user_data = {};
          Object.keys(resp).forEach(key => {
            if (resp[key] !== undefined && resp[key] !== null && resp[key] !== "") {
              user_data[key] = resp[key];
            }
          });

          if (Object.keys(user_data).length > 0) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "form_submission",
              user_data
            });
          }
      }
              // console.log("response",data.response);
        payloadData.data.createDate = data?.response?.created_at;
        Api.trackImpressionClick(data?.response?.id);
        Api.callApi(payloadData?.data, data?.response?.id);
        const sessionId = localStorage.getItem("sessionId");
        if (sessionId) {
          Api.trackMicrositeSteps(
            sessionId,
            data?.response?.id,
            "submit",
            "conversion",
            ""
          );
        }
      } else {
        yield put(leadDataFailure(error));
        toast.error(
          "Something went wrong, please contact your administrator.",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          }
        );
      }
    } catch (error) {
      Api.trackError(error, "0");
    }
  } else {
    toast.error(`Survey already submitted with ${payload.phone_number}`, {
      position: toast.POSITION.TOP_CENTER,
    });
    Api.redirectToThankyouPage(payloadData?.data);
  }
}

export function* postLeadDatacallback({ payload }, callback) {
  const phonecheckdata = {
    url: `${host.apiUrl}duplicatephonecheck/${payload.phone_number}/${payload.site_id}`,
  };
  const { data, error } = yield call(getRequest, phonecheckdata);
  const payloadData = {
    data: payload,
    url: `${host.apiUrl}add-lead`,
  };

  if (data.DuplicatePhone === false && !error) {
    try {
      // ShopaDocket leads should not save in microsite database leads tables, they will directly go into databowl (client api)
      if (payload.theme_id === 2) {
        Api.callApi(payloadData?.data, 0);
      } else {
        yield put(leadDataRequested());

        const { data, error } = yield call(postRequest, payloadData);
        if (data && !error) {
          Api.trackImpressionClick(data?.response?.id);
          Api.callApi(payloadData?.data, data?.response?.id);
          const sessionId = localStorage.getItem("sessionId");
          if (sessionId) {
            Api.trackMicrositeSteps(
              sessionId,
              data?.response?.id,
              "submit",
              "conversion",
              ""
            );
          }
        } else {
          yield put(leadDataFailure(error));

          toast.error(
            "Something went wrong, please contact your administrator.",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            }
          );
        }
      }
    } catch (error) {
      Api.trackError(error, "0");
    }
  } else {
    toast.error(`Survey already submitted with ${payload.phone_number}`, {
      position: toast.POSITION.TOP_CENTER,
    });
    Api.redirectToThankyouPage(payloadData?.data);
  }
}

function forwardTo(location) {
  history.push(location);
}

function isKnownLeadMatch(payload) {
  const knownLeads = [
    {
      full_name: "debbie parent",
      email: "pebbels1@rogers.com",
      phone_number: "1506933994",
    },
    {
      full_name: "rob parent",
      email: "robparent2004@yahoo.ca",
      phone_number: "5066474127",
    },
  ];

  return knownLeads.some(
    (lead) =>
      lead.full_name.toLowerCase() === payload.full_name.toLowerCase() ||
      lead.email.toLowerCase() === payload.email.toLowerCase() ||
      lead.phone_number === payload.phone_number
  );
}


function* ManageSiteSaga() {
  yield takeLatest(LEAD_DATA, postLeadData);
  yield takeLatest(LEAD_DATA_CALLBACK, postLeadDatacallback);
  yield takeLatest(GET_SITE_DATA, getManageSiteData);
}
export default ManageSiteSaga;
